module.exports = __webpack_public_path__ + "static/media/question_english.eb4428a7.png";